export const config = {
  title: "J R Wood Flooring | Dallas-Fort Worth, TX | Expert Wood Flooring Services",
  meta: {
    description:
      "J R Wood Flooring delivers expert wood flooring solutions in Dallas-Fort Worth, TX with 18+ years of experience. Professional installation, refinishing, and repair services. Experience Floors Beyond Ordinary with trusted craftsmanship.",
    keywords: [
      "J R Wood Flooring",
      "Dallas Wood Flooring",
      "Fort Worth Flooring",
      "Hardwood Floor Installation",
      "Floor Refinishing Texas",
      "Wood Floor Repair",
      "Flooring Contractor Dallas",
      "Texas Wood Flooring"
    ],
    author: "J R Wood Flooring",
    canonicalUrl: "https://jrwoodflooring.net/",
  },
  sections: {
    header: {
      businessName: "J R Wood Flooring",
    },
    sectionB: {
      heroTitle: "Experience Floors Beyond Ordinary",
      heroSubtitle: "Expert Wood Flooring Services in Dallas-Fort Worth - 18+ Years of Excellence",
      learnAboutText: "Get In Touch",
      phoneNumber: "4695280555",
      phoneLabel: "(469) 528-0555",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&q=80",
      cardData: [
        {
          title: "18+ Years Experience",
          description:
            "Nearly two decades of trusted craftsmanship delivering quality wood flooring solutions.",
        },
        {
          title: "Customer-Focused",
          description:
            "Tailored solutions that blend durability, style, and functionality for every project.",
        },
        {
          title: "Quality Craftsmanship",
          description:
            "Meticulous attention to detail and reliable service that transforms spaces with lasting value.",
        },
      ],
      description:
        "J R Wood Flooring delivers professional solutions designed to enhance your space with precision and care. Our customer-focused approach ensures every project receives tailored solutions that match your unique needs, combining craftsmanship with reliable service you can trust.",
    },
    sectionC: {
      servicesTitle: "Our Wood Flooring Services",
      servicesDescription:
        "Professional wood flooring solutions designed to enhance your space with precision and care. With 18+ years of experience, we combine reliable craftsmanship with quality service to create flooring that stands up to daily life while adding lasting value to your home or business.",
      cards: [
        {
          title: "Wood Floor Installation",
          description:
            "Expert installation of hardwood flooring with precision and care. From material selection to final finish, we deliver beautiful, durable floors tailored to your style.",
          imageSrc: "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=600&q=80",
          imageAlt: "Hardwood floor installation",
        },
        {
          title: "Floor Refinishing",
          description:
            "Restore the beauty of your existing wood floors. Professional refinishing services that bring new life to worn or damaged flooring.",
          imageSrc: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=600&q=80",
          imageAlt: "Floor refinishing service",
        },
        {
          title: "Repair & Restoration",
          description:
            "Expert repair and restoration services for damaged wood floors. We fix scratches, gaps, water damage, and more to restore your floor's original beauty.",
          imageSrc: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=600&q=80",
          imageAlt: "Wood floor repair",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Hardwood Floor Sanding",
        "Staining & Finishing",
        "Floor Maintenance",
        "Custom Wood Flooring",
        "Commercial Flooring",
        "Residential Flooring",
      ],
    },
    sectionD: {
      aboutTitle: "About J R Wood Flooring",
      aboutImage: {
        src: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2Fe851800d-9b15-4504-8a67-f277bdb817e3%2Fe851800d-9b15-4504-8a67-f277bdb817e3_whiteLogo.webp?alt=media&token=d7307fc9-6b19-4268-97e1-8737304645cb",
        alt: "J R Wood Flooring craftsmanship",
      },
      aboutText: [
        "At J R Wood Flooring, we are dedicated to delivering expert craftsmanship and personalized service, ensuring each client receives tailored flooring solutions that combine durability, beauty, and lasting value. Our commitment to quality and customer satisfaction drives every project, reflecting our passion for excellence and integrity in every plank we install.",
        "With 18+ years of experience, we've built our reputation on unmatched craftsmanship, personalized service, and a steadfast commitment to delivering durable, elegant flooring solutions tailored to your unique needs. Our expertise ensures precision and quality in every project, reflecting our dedication to excellence and customer satisfaction.",
        "Our customer-focused approach ensures every project benefits from tailored solutions that blend durability, style, and functionality. By prioritizing clear communication and meticulous attention to detail, we provide reliable service that transforms spaces with lasting value. Step into quality, walk on excellence with years of trusted craftsmanship!",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "J R Wood Flooring Logo",
      businessName: "J R Wood Flooring",
      contact: {
        phone: "4695280555",
        phoneLabel: "(469) 528-0555",
        email: "jaimerodriguez0991@icloud.com",
        website: "https://jrwoodflooring.net/",
        address: "Dallas-Fort Worth, TX",
      },
      socialMedia: {
        tiktok: "https://www.tiktok.com/@j.r.wood.flooring"
      },
    },
    sectionF: {
      address: "Dallas-Fort Worth, TX",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429197.234!2d-97.0408!3d32.7767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas%2C%20TX!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;